module.exports = __webpack_public_path__ + "static/media/scorbit-vision-admin.4365ff4c.png";